class CollectionHeaderBanner extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Connected Callback Hook
   * Is called when the component is inserted into the DOM
   */
  connectedCallback() {
    // Check if the component is actually connected to the DOM
    if (!this.isConnected) return;

    // Component elements
    this.DOMBody = document.querySelector("body");
    this.bannerVideo = this.querySelector(".collection-header-banner-video");
    this.bannerVideoOverlay = this.querySelector(
      ".collection-header-banner-video-overlay"
    );
    this.iframe = this.querySelector("iframe");

    // If no bannerVideo element found, exit function
    if (!this.bannerVideo) return;

    // Component event listener
    this.addEventListener("click", this.componentEventHandler.bind(this));
  }

  /**
   * Disconnected Callback Hook
   * Called when the component is removed from the DOM
   */
  disconnectedCallback() {
    this.removeEventListener("click", this.componentEventHandler, true);
  }

  /**
   * Event handler for click events
   * @param {Event} event Component click event object
   */
  componentEventHandler(event) {
    const videoOverlay = event.target.closest(
      ".collection-header-banner-video-overlay"
    );

    // Overlay element
    if (videoOverlay) {
      this.closeVideo();
      return;
    }

    this.openVideo();
  }

  /**
   * Open video
   */
  openVideo() {
    this.bannerVideo.dataset.showHeaderBannerVideo = true;
    this.DOMBody.classList.add("overflow-hidden");
  }

  /**
   * Close Video
   */
  closeVideo() {
    this.bannerVideo.dataset.showHeaderBannerVideo = false;
    this.DOMBody.classList.remove("overflow-hidden");
    this.pauseVideo();
  }

  /**
   * Pause Video
   * Pause video by replacing the iframe src with it's own src
   */
  pauseVideo() {
    const src = this.iframe.src;
    this.iframe.src = src;
  }
}

customElements.define("collection-header-banner", CollectionHeaderBanner);
